import { render, staticRenderFns } from "./MaterialView.vue?vue&type=template&id=4fb3efff"
import script from "./MaterialView.vue?vue&type=script&lang=js"
export * from "./MaterialView.vue?vue&type=script&lang=js"
import style0 from "./MaterialView.vue?vue&type=style&index=0&id=4fb3efff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports